import { Link } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { Plus } from 'lucide-react'
import { ReactNode } from 'react'

type SectionHeaderProps = {
  title: string
  count?: number
  action?: {
    label: string
    href?: string
    onClick?: () => void
  }
  children?: ReactNode
}

export function SectionHeader({ title, count, action, children }: SectionHeaderProps) {
  return (
    <div className="flex items-center justify-between py-2 border-b border-border/40">
      <div className="flex items-center gap-2">
        <h2 className="text-sm font-medium">{title}</h2>
        {count !== undefined && (
          <span className="text-[12px] text-muted-foreground">{count}</span>
        )}
      </div>
      {action && (
        action.href ? (
          <Button size="sm" variant="ghost" asChild className="gap-1 text-[12px] h-7 text-muted-foreground hover:text-foreground">
            <Link href={action.href}>
              <Plus className="w-3 h-3" />
              {action.label}
            </Link>
          </Button>
        ) : (
          <Button size="sm" variant="ghost" onClick={action.onClick} className="gap-1 text-[12px] h-7 text-muted-foreground hover:text-foreground">
            <Plus className="w-3 h-3" />
            {action.label}
          </Button>
        )
      )}
      {children}
    </div>
  )
}
